import cx from 'classnames'
import { Text } from 'blaze-ui/Text/Text'
import Styles from './BrandWizardIntegrationSelection.module.scss'
import { DropdownTrigger } from 'components/DropdownTrigger/DropdownTrigger'
import { Menu } from 'components/Menu/Menu'
import { Item } from '@react-stately/collections'
import { Facebook, Instagram } from 'blaze-ui/icons'
import { Pressable } from '@react-aria/interactions'
import { ExternalIntegrationEnum } from 'api/clients/ExternalIntegrationsClient'
import { DOMAttributes, DOMProps, Key } from '@react-types/shared'
import { forwardRef } from 'react'
import { useInitiateOauth } from 'hooks/useInitiateOauth'

const Trigger = forwardRef<HTMLDivElement, DOMProps & DOMAttributes>((props, fRef) => {
  const isPressed = props['aria-expanded']

  return (
    <div className={cx(Styles.newIntegrationCard, { [Styles.pressed]: isPressed })} ref={fRef} {...props}>
      <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="15" height="15" rx="7.5" fill="var(--dark-80)" />
        <path d="M7.51502 4.5V10.5M10.5 7.4831H4.5" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
      </svg>

      <Text variant="label" color="var(--dark-80)">
        Connect Another Account
      </Text>
    </div>
  )
})

export const NewIntegrationCard = () => {
  const { initiateOauth } = useInitiateOauth()

  const handleAction = (key: Key) => {
    const provider = key as ExternalIntegrationEnum
    initiateOauth(provider)
  }

  return (
    <DropdownTrigger>
      <Pressable>
        <Trigger />
      </Pressable>
      {(close) => (
        <Menu
          aria-label="Connect Another Account"
          onAction={(key) => {
            handleAction(key)
            close()
          }}
        >
          <Item key="instagram" textValue="Instagram">
            <Instagram /> Instagram
          </Item>
          <Item key="facebook" textValue="Facebook">
            <Facebook /> Facebook
          </Item>
        </Menu>
      )}
    </DropdownTrigger>
  )
}
